import {Component} from '@angular/core';
/**
 * \@title Configurable slide-toggle
 */
export class SlideToggleConfigurableExample {
  color = 'accent';
  checked = false;
  disabled = false;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'slide-toggle-configurable-example',
  templateUrl: 'slide-toggle-configurable-example.html',
  styleUrls: ['slide-toggle-configurable-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SlideToggleConfigurableExample_tsickle_Closure_declarations() {
/** @type {?} */
SlideToggleConfigurableExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SlideToggleConfigurableExample.ctorParameters;
/** @type {?} */
SlideToggleConfigurableExample.prototype.color;
/** @type {?} */
SlideToggleConfigurableExample.prototype.checked;
/** @type {?} */
SlideToggleConfigurableExample.prototype.disabled;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
